import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  enotesLessonsData: [],
  totalenotesLessons: 0,
  isOpenModal: false,
}

export const enotesLessonsSlice = createSlice({
  name: "enotesLessons",
  initialState,
  reducers: {
    setenotesLessonsData(state, { payload }) {
      state.enotesLessonsData = payload.result
      state.totalenotesLessons = payload.count
    },
    updateenotesLessonsData(state, { payload }) {
      const objIndex = state.enotesLessonsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.enotesLessonsData[objIndex] = payload
      }
    },
    deleteenotesLessonsData(state, { payload }) {
      const objIndex = state.enotesLessonsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.enotesLessonsData.splice(objIndex, 1)
      }
    },
    pushenotesLessonsData(state, { payload }) {
      state.enotesLessonsData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setenotesLessonsData, updateenotesLessonsData, deleteenotesLessonsData, pushenotesLessonsData, isOpenModal,
  ModalToggle } = enotesLessonsSlice.actions;

export default enotesLessonsSlice.reducer;

export function getenotesLessons(limit, offset, status, keyword) {
  return async function getenotesLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getenotesLessons(limit, offset, status, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setenotesLessonsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addenotesLessons(payload) {
  return async function addenotesLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addenotesLessons(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushenotesLessonsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateenotesLessons(id, data) {
  return async function updateenotesLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateenotesLessons(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateenotesLessonsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleteenotesLessons(id) {
  return async function statuseleteenotesLessonsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateenotesLessons(id).then(
        (response) => {
          dispatch(deleteenotesLessonsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



